import { render, staticRenderFns } from "./ContentParametersEditionModal.vue?vue&type=template&id=32504bea&scoped=true&"
import script from "./ContentParametersEditionModal.vue?vue&type=script&lang=js&"
export * from "./ContentParametersEditionModal.vue?vue&type=script&lang=js&"
import style0 from "./ContentParametersEditionModal.vue?vue&type=style&index=0&id=32504bea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32504bea",
  null
  
)

export default component.exports